import { IFormInput } from "@shared/hooks";
import { FormType } from "../types/userFormTypes";

const validatePhoneNumber = (_: any, value: string) => {
    if (!value) return Promise.reject();

    const cleanedPhone = value.replace(/[\s\-\(\)]/g, '');

    if (!/^\d{8,15}$/.test(cleanedPhone)) {
        return Promise.reject();
    }

    return Promise.resolve();
};

const createRequiredRule = (messageKey: string) => ({ required: true, message: messageKey });

const createPhoneRules = (requiredMessageKey: string, invalidMessageKey: string) => [
    createRequiredRule(requiredMessageKey),
    { validator: validatePhoneNumber, message: invalidMessageKey }
];

const personalDataRules = {
    firstName: [createRequiredRule("screens.profile.personalData.validation.first-name.required")],
    lastName: [createRequiredRule("screens.profile.personalData.validation.last-name.required")],
    email: [
        createRequiredRule("screens.profile.personalData.validation.email.required"),
        { type: "email", message: "screens.profile.personalData.validation.email.invalid" }
    ],
    phone: createPhoneRules(
        "screens.profile.personalData.validation.phone-number.required",
        "screens.profile.personalData.validation.phone-number.invalid"
    ),
    phonePrefix: []
};

const emergencyContactRules = {
    firstName: [createRequiredRule("screens.profile.emergencyContact.validation.firstName.required")],
    lastName: [createRequiredRule("screens.profile.emergencyContact.validation.last-name.required")],
    phone: createPhoneRules(
        "screens.profile.emergencyContact.validation.phone-number.required",
        "screens.profile.emergencyContact.validation.phone-number.invalid"
    ),
    phonePrefix: [],
    relationship: [createRequiredRule("screens.profile.emergencyContact.validation.relationship.required")]
};

export const USER_FORM_INPUTS: Record<FormType, { title: string; inputs: IFormInput[] }> = {
    personal_data: {
        title: "screens.profile.personalData.title",
        inputs: [
            {
                name: "first_name",
                label: "screens.profile.personalData.first-name",
                returnKeyType: "next",
                keyboardType: "default",
                rules: personalDataRules.firstName,
                editable: false
            },
            {
                name: "last_name",
                label: "screens.profile.personalData.last-name",
                returnKeyType: "next",
                keyboardType: "default",
                rules: personalDataRules.lastName,
                editable: false
            },
            {
                name: "phone_number",
                prefixName: "phone_country_code_prefix",
                label: "screens.profile.personalData.phone-number",
                type: "phone" as const,
                returnKeyType: "next",
                keyboardType: "phone-pad",
                rules: personalDataRules.phone,
                prefixRules: personalDataRules.phonePrefix
            },
            {
                name: "email",
                label: "screens.profile.personalData.email",
                returnKeyType: "done",
                keyboardType: "email-address",
                rules: personalDataRules.email,
                editable: false
            }
        ]
    },
    emergency_contact: {
        title: "screens.profile.emergencyContact.title",
        inputs: [
            {
                name: "emergency_contacts.0.first_name",
                label: "screens.profile.emergencyContact.firstName",
                returnKeyType: "next",
                keyboardType: "default",
                rules: emergencyContactRules.firstName
            },
            {
                name: "emergency_contacts.0.last_name",
                label: "screens.profile.emergencyContact.lastName",
                returnKeyType: "next",
                keyboardType: "default",
                rules: emergencyContactRules.lastName
            },
            {
                name: "emergency_contacts.0.phone_number",
                prefixName: "emergency_contacts.0.country_code_prefix",
                label: "screens.profile.emergencyContact.phoneNumber",
                type: "phone" as const,
                returnKeyType: "next",
                keyboardType: "phone-pad",
                rules: emergencyContactRules.phone,
                prefixRules: emergencyContactRules.phonePrefix
            },
            {
                name: "emergency_contacts.0.relationship",
                label: "screens.profile.emergencyContact.relationship",
                returnKeyType: "done",
                keyboardType: "default",
                rules: emergencyContactRules.relationship
            }
        ]
    }
};
